import { RecordDataSource } from "../../../records/grids";
import {
  ColumnDefinitionSetService,
  vsServiceName as ColumnDefinitionSetServiceName,
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import { machineObjectName as machineName } from "../../../machines/shared/names";
import { vsObjectName as contractInstanceName } from "./contractInstance";

export const vsObjectName = "contractInstanceMachine";
export const vsMachineColumnSetName = `${vsObjectName}.machine`;
export const vsContractColumnSetName = `${vsObjectName}.contract`;

contractMachineConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
export function contractMachineConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider,
) {
  columnDefinitionSetServiceProvider.addColumnDefinitionSet(
    vsMachineColumnSetName,
    [
      ColumnDefinitionSetServiceName,
      (columnDefinitionSetService: ColumnDefinitionSetService) =>
        columnDefinitionSetService.getColumnDefinitionSet(machineName) ?? [],
    ],
  );

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(
    vsContractColumnSetName,
    [
      ColumnDefinitionSetServiceName,
      (columnDefinitionSetService: ColumnDefinitionSetService) =>
        columnDefinitionSetService.getColumnDefinitionSet(
          contractInstanceName,
        ) ?? [],
    ],
  );

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionSetServiceName,
    (columnDefinitionSetService: ColumnDefinitionSetService) => [
      ...(columnDefinitionSetService.getColumnDefinitionSet(
        contractInstanceName,
      ) ?? []),
      ...(columnDefinitionSetService.getColumnDefinitionSet(machineName) ?? []),
    ],
  ]);

  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService,
    ): GridConfiguration => {
      return {
        defaultSort: "SerialNumber,ContractNumber",
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/contract/machines",
        ),
        gridSettings: gridSettingsService.getGridSettings(Symbol(vsObjectName)),
        namePlural: "Contract Machines",
        nameSingular: "Contract Machine",
        showAddButton: false,
        columnDefinitionSet: vsObjectName,
      };
    },
  ]);
}
